import React from "react";

const Settings = () => {
  return (
    <div>
      <h1>welcome to Settings component</h1>
    </div>
  );
};

export default Settings;
